/// <amd-module name="TFS/Admin/Groups/Pivots/Permissions/Redux/PermissionsPivotModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IPermissionsPivotAwareState } from "TFS/Admin/Groups/Common/Contracts";
import { permissionsPivotReducer } from "TFS/Admin/Groups/Pivots/Permissions/Redux/PermissionsPivotReducers";
import { PermissionsPivotSaga } from "TFS/Admin/Groups/Pivots/Permissions/Redux/PermissionsPivotSaga";

export function getPermissionsPivotModule(): ISagaModule<IPermissionsPivotAwareState> {
    const reducerMap: ReducersMapObject<IPermissionsPivotAwareState, AnyAction> = {
        permissions: permissionsPivotReducer
    };

    return {
        id: "permissionsPivotState",
        reducerMap,
        sagas: [PermissionsPivotSaga]
    };
}
